import { fetch } from '../utility/fetch.js';

export const questionTypesNamed = {
  selectFromList: {
    ID: 1,
    Type: 'Select (provide answers)',
    allowsDependency: true,
    fieldType: 'select',
  },
  selectFromTable: {
    ID: 2,
    Type: 'Select (answers in table)',
    allowsDependency: true,
    fieldType: 'select',
  },
  text: { ID: 3, Type: 'Text', fieldType: 'Text' },
  textArea: { ID: 4, Type: 'Text Area', fieldType: 'TextArea' },
  checkbox: {
    ID: 5,
    Type: 'Checkbox',
    allowsDependency: true,
    fieldType: 'Checkbox',
  },
  infotext: {
    ID: 6,
    Type: 'Informational Text (no response)',
    fieldType: 'Label',
  },
  selectFromColumn: {
    ID: 7,
    Type: 'Select (values in column)',
    allowsDependency: true,
    fieldType: 'select',
  },
};
export const defaultQuestionType = questionTypesNamed.text;
export const questionType = [
  questionTypesNamed.selectFromList,
  questionTypesNamed.selectFromTable,
  questionTypesNamed.text,
  questionTypesNamed.textArea,
  questionTypesNamed.checkbox,
  questionTypesNamed.infotext,
  questionTypesNamed.selectFromColumn,
];

export const getFieldType = (type) => {
  return questionType
    .filter((item) => item.ID === type)
    .map((item) => item.fieldType)[0];
};

let optionResponseCache = {};
const getTableSourcedOptions = async (table, column, column2) => {
  if (column2) {
    // populated during the review because the asset ID is needed
    return [];
  }
  const cacheKey = `${table}-${column}`;
  if (optionResponseCache[cacheKey] === undefined) {
    optionResponseCache[cacheKey] = fetch('/Common/GetDistinctColumnValues', {
      table,
      column,
    });
  }
  return optionResponseCache[cacheKey];
};
// eslint-disable-next-line complexity
export const getOptions = async (question) => {
  if (!question.Options && question.Table && question.Field) {
    question.Options = await getTableSourcedOptions(
      question.Table,
      question.Field,
      question.Field2
    );
  }
  let fieldType = getFieldType(question.Type);
  if (
    (fieldType == 'select' || fieldType == 'Checkbox') &&
    !(question.Options instanceof Array) &&
    isNaN(question.Options)
  ) {
    question.Options = question.Options.split('|');
  }
  return question.Options;
};

/**
 * Checks whether a question should be shown by checking it's dependency chain
 * to ensure all it's ancestor dependents have the appropriate responses
 * @param {object} question The question to check
 * @param {object[]} allQuestions The list of all questions
 * @returns {boolean} Whether the question is fulfilled
 */
export const dependencyChainFulfilled = (question, allQuestions) => {
  if (!question.Dependency) {
    return true;
  }

  const { QuestionId, Answer } = question.Dependency;
  const target = allQuestions.find(
    (q) => q.ID === QuestionId || q.Id === QuestionId
  );
  if (!target) {
    return false;
  }

  let targetIsFulfilled = false;
  if (target.newValue instanceof Array) {
    targetIsFulfilled = target.newValue.includes(Answer);
  } else {
    if (target.newValue != undefined) {
      let targetArray = [];
      targetArray = target.newValue.split(',');
      targetIsFulfilled = targetArray.includes(Answer);
    }
  }
  return targetIsFulfilled && dependencyChainFulfilled(target, allQuestions);
};
